const topics = [
  { label: '动作冒险', count: '3.2万', hot: true },
  { label: '悬疑推理', count: '2.8万', hot: true },
  { label: '科幻奇幻', count: '2.5万', hot: false },
  { label: '喜剧搞笑', count: '3.6万', hot: true },
  { label: '爱情文艺', count: '2.1万', hot: false },
  { label: '恐怖惊悚', count: '1.9万', hot: false },
  { label: '国产剧集', count: '4.8万', hot: true },
  { label: '日韩剧集', count: '2.3万', hot: false },
  { label: '欧美剧集', count: '2.7万', hot: false },
  { label: '动漫番剧', count: '3.1万', hot: true },
  { label: '纪录片', count: '1.4万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            大家都在讨论的影视热点，发现最受欢迎的内容方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-100 border-accent-200 text-accent-800 hover:bg-accent-200'
                  : 'bg-background-100 border-background-200 text-foreground-600 hover:border-primary-200 hover:text-primary-600'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              )}
              <span>{topic.label}</span>
              <span className="text-xs opacity-60">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}